import { useEffect, useState } from "react";
import { useApiClient } from "../contexts/ApiContext";

/**
 * Whether the signed-in user is an admin of their tenant, or `undefined`
 * while that's being checked. Fails closed: if the check errors, they aren't.
 *
 * The API enforces this on every admin-only call; this only decides what to
 * show. Asked of the API rather than read from the session because the role
 * lives on better-auth's `members` row, which the session doesn't carry.
 */
export function useIsTenantAdmin(): boolean | undefined {
	const apiClient = useApiClient();
	const [isTenantAdmin, setIsTenantAdmin] = useState<boolean>();

	useEffect(() => {
		let cancelled = false;
		apiClient.admin
			.getMyAccess()
			.then((access) => {
				if (!cancelled) {
					setIsTenantAdmin(access.isTenantAdmin);
				}
			})
			.catch((error: unknown) => {
				console.error("Failed to check admin access:", error);
				if (!cancelled) {
					setIsTenantAdmin(false);
				}
			});
		return () => {
			cancelled = true;
		};
	}, [apiClient]);

	return isTenantAdmin;
}
